import AddButton from "components/buttons/addbutton";
import ListButtons from "components/buttons/listButtons";
import ListHeadingComponent from "components/headingComponent/listHeading";
import {
  query,
  collection,
  orderBy,
  getDocs,
  and,
  or,
  where,
  limit,
  startAfter,
  endBefore,
  limitToLast,
  deleteDoc,
  doc,
  Timestamp,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import Constant from "helper/constant/constant";
import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import moment from "moment";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { ButtonGroup } from "react-bootstrap";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

const StudentsPerformanceList = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [performanceData, setPerformanceData] = useState([]); // we fetch the data from the backend and shown in the form of list
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  //these are pagination variables
  const [filteredDates, setFilteredDates] = useState(null);
  const [page, setPage] = useState(0);
  const [isNext, setIsNext] = useState(false);

  // MARK: use Effect function
  useEffect(() => {
    fetchStudentsPerformancesApi();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //  use layout effect function
  useLayoutEffect(() => {
    document.title = CommonHeadings.studentMarksLayoutHeading;
  }, []);

  // MARK:  function using in input
  const tapOnDateInput = (e) => {
    setFilteredDates(e.value);
  };

  //  for showing data in the list
  const nameAndAdmission = (student) => {
    return student.student_name + " - " + student.admission_number;
  };

  // MARK: tap on button
  //  Edit data function
  const tapOnEdit = (studentsPerformanceData) => () => {
    navigate(RoutingPaths.editStudentPerformance, {
      state: studentsPerformanceData,
    });
  };

  // Delete data function
  const tapOnDeleteConfirm = (studentsPerformanceData) => () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete this student marks detail`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        deleteStudentsPerformanceApi(studentsPerformanceData);
      }
    });
  };

  // reset button function
  const tapOnResetButton = () => {
    setFilteredDates(null);
    fetchStudentsPerformancesApi();
  };

  // MARK: API
  // delete API
  const deleteStudentsPerformanceApi = async (studentsPerformanceData) => {
    await deleteDoc(
      doc(dbFirestore, TableName.studentPerformance, studentsPerformanceData.id)
    );
    setPerformanceData((prevState) =>
      prevState.filter((el) => el.id !== studentsPerformanceData.id)
    );
    toast.success(ToastMessages.demoStudentsDelete);
  };

  // fetch student's performance API
  async function fetchStudentsPerformancesApi() {
    let q = query(
      collection(dbFirestore, TableName.studentPerformance),
      orderBy("created_at", "desc"),
      limit(Constant.perPage)
    );
    const querySnapshot = await getDocs(q);
    setPerformanceData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setLoading(false);
    setPage(0);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  }

  // serach api
  const searchPteStudentsApi = async (e) => {
    const searchText = e.target.value.toLowerCase();
    setGlobalFilterValue(searchText);

    if (searchText) {
      let q = query(
        collection(dbFirestore, TableName.studentPerformance),
        or(
          and(
            where("student_name", ">=", searchText),
            where("student_name", "<=", searchText + "\uf8ff")
          ),
          and(
            where(
              "student_name",
              ">=",
              searchText.charAt(0).toUpperCase() + searchText.slice(1)
            ),
            where(
              "student_name",
              "<=",
              searchText.charAt(0).toUpperCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          ),
          and(
            where(
              "student_name",
              ">=",
              searchText.charAt(0).toLowerCase() + searchText.slice(1)
            ),
            where(
              "student_name",
              "<=",
              searchText.charAt(0).toLowerCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          )
        )
      );
      const querySnapshot = await getDocs(q);

      setPerformanceData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
    } else {
      fetchStudentsPerformancesApi();
    }
  };

  // MARK: pagination code
  const showNext = ({ item }) => {
    const fetchNextData = async () => {
      var paginationQuery;

      paginationQuery = query(
        collection(dbFirestore, TableName.studentPerformance), where(
          "created_at",
          ">=",
          getFilteredDatesTimeStamp().startTime
        ),
        where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
        orderBy("created_at", "desc"),
        limit(Constant.perPage),
        startAfter(item.created_at)
      );

      const querySnapshot = await getDocs(paginationQuery);

      setPerformanceData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );
      setPage(page + 1);
      setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    };

    if (performanceData.length === 0) {
      alert(ToastMessages.alertMessage);
    } else {
      fetchNextData();
    }
  };

  // previous data function using pagination previous button
  const fetchPreviousData = async () => {
    setPage(page - 1);

    var paginationQuery;
    paginationQuery = query(
      collection(dbFirestore, TableName.studentPerformance), where(
        "created_at",
        ">=",
        getFilteredDatesTimeStamp().startTime
      ),
      where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
      orderBy("created_at", "desc"),
      endBefore(performanceData[0].created_at),
      limitToLast(Constant.perPage)
    );

    const querySnapshot = await getDocs(paginationQuery);

    setPerformanceData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setPage(page - 1);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  // condition while selecting the previous button
  const showPrevious = () => {
    if (performanceData.length === 0) {
      fetchStudentsPerformancesApi();
    } else {
      fetchPreviousData();
    }
  };

  // MARK: filter dates
  function getFilteredDatesTimeStamp() {
    if (filteredDates) {
      const startDate = moment(filteredDates[0]).format(Dateformat.YYYYMMDD);
      const endDate = moment(filteredDates[1]).format(Dateformat.YYYYMMDD);

      const startTimestamp = Timestamp.fromDate(new Date(startDate)).toMillis();
      const endTimestamp = Timestamp.fromDate(new Date(endDate)).toMillis();
      return { startTime: startTimestamp, endTime: endTimestamp };
    }
    return null;
  }

  async function createQueryForTable() {
    const filterText = filteredDates;

    if (!filterText) {
      toast.error(ToastMessages.filterDate);
      <ToastContainer />
    }

    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.studentPerformance),
        where(
          "created_at",
          ">=",
          getFilteredDatesTimeStamp().startTime
        ),
        where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
        limit(Constant.perPage),
        orderBy("created_at", "desc")
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.studentPerformance),
        orderBy("created_at", "desc"),
        limit(Constant.perPage)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }

  async function createQueryForExport() {
    const filterText = filteredDates;
    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.studentPerformance),
        where(
          "created_at",
          ">=",
          getFilteredDatesTimeStamp().startTime
        ),
        where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
        limit(Constant.perPage),
        orderBy("created_at", "desc")
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.studentPerformance),
        orderBy("created_at", "desc"),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }

  // MARK: filter function using in input
  const tapOnFilterButton = async () => {
    const querySnapshot = await createQueryForTable();
    const array = querySnapshot.docs.map((docs) => ({ ...docs.data() }));
    setPerformanceData(array);
  };

  // MARK: modify student model in which we add new inputs in an array
  const modifyStudentModel = (doc) => {
    const data = doc.data();

    return {
      admission_number: data.admission_number,
      student_name: data.student_name,
      test_date: moment(data.test_date_timestamp).format(
        Dateformat.YYYYMMDD
      ),
      speaking_marks: data.speaking_marks,
      writing_marks: data.writing_marks,
      listening_marks: data.listening_marks,
      reading_marks: data.reading_marks,
      overall_marks: data.overall_marks,
      created_at: moment(data.created_at).format(
        Dateformat.YYYYMMDD
      ),

    };
  };

  // MARK: export data in the excel sheet
  const exportToExcel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to export these data.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.value) {
        const querySnapShot = await createQueryForExport();

        const mylist = querySnapShot.docs.map((model) =>
          modifyStudentModel(model)
        );

        const filterUserData = mylist.map(
          ({
            admission_number,
            student_name,
            test_date,
            speaking_marks,
            writing_marks,
            listening_marks,
            reading_marks,
            overall_marks,
            created_at,
          }) => ({
            admission_no: admission_number,
            student_name: student_name,
            test_date: test_date,
            speaking_marks: speaking_marks,
            writing_marks: writing_marks,
            listening_marks: listening_marks,
            reading_marks: reading_marks,
            overall_marks: overall_marks,
            created_at: created_at,
          })
        );
        if (filteredDates) {
          const workBook = XLSX.utils.book_new();
          const workSheet = XLSX.utils.json_to_sheet(filterUserData);
          XLSX.utils.book_append_sheet(workBook, workSheet, "students");
          XLSX.writeFile(workBook, "students_performance_data.xlsx");
        } else {
          toast.error(ToastMessages.filterDate)
        }
      }
    });
  };

  // MARK: UI start
  // Search UI
  const searchBar = () => {
    return (
      <>
        <div className="search__main_div">
          <div style={{ flexGrow: "1" }}>
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText
                type="search"
                value={globalFilterValue}
                onChange={searchPteStudentsApi}
                placeholder="Search by name"
              />
            </IconField>
          </div>
          <div className="filter__button-section">
            <Calendar
              value={filteredDates}
              onChange={tapOnDateInput}
              selectionMode="range"
              readOnlyInput
              showIcon
              placeholder="Select start and end date"
            />

            <Button
              type="button"
              label="Filter"
              className="list__filter_button ms-2 me-2"
              onClick={tapOnFilterButton}
            />
            <Button
              type="button"
              label="Reset"
              className="list__reset_button"
              onClick={tapOnResetButton}
            />
          </div>
        </div>
      </>
    );
  };

  const header = searchBar();

  // students performance columns data
  const studentsPerformanceColumns = [
    {
      header: "Name", className: "table__column__capital",
      CardBody: (data) => nameAndAdmission(data)
    },
    {
      field: "test_date",
      header: "Test Date",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYY}>{data.test_date}</Moment>
      ),
    },
    { field: "overall_marks", header: "Overall Marks" },
    {
      field: "created_at",
      header: "Created At",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYHHMMSS}>{data.created_at}</Moment>
      ),
    },
    {
      field: "actions",
      header: "Actions",
      CardBody: (data) => (
        <>
          <ListButtons
            editclick={tapOnEdit(data)}
            deleteclick={tapOnDeleteConfirm(data)}
          />
          <ToastContainer />
        </>
      ),
    },
  ];

  if (isLoading) {
    return <div className="loading-div"> Loading ... </div>;
  }


  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <div className="modules__lists_main-content">
            <ListHeadingComponent
              classname="flex-grow-1"
              headingName={CommonHeadings.studentMarksLayoutHeading}
            />
            <Button
              label="Export Data"
              type="button"
              onClick={exportToExcel}
              className="list__export_button me-2"
            />
            <AddButton navigation={RoutingPaths.addStudentPerformance} />
          </div>

          <DataTable
            className="mt-5 mb-3"
            value={performanceData}
            header={header}
            emptyMessage="No data found."
          >
            {studentsPerformanceColumns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                bodyClassName={col.className}
                body={col.CardBody}
              />
            ))}
          </DataTable>

          <ButtonGroup
            style={{ gap: "1rem", alignSelf: "center" }}
            className="mt-5"
          >
            {
              <button
                disabled={page === 0 ? true : false}
                onClick={() => showPrevious()}
                className={
                  page === 0 ? "previous-disabled-button" : "previous-button"
                }
              >
                <span className="pi pi-angle-left">Previous</span>
              </button>
            }

            {
              <button
                disabled={isNext}
                onClick={() =>
                  showNext({ item: performanceData[performanceData.length - 1] })
                }
                className={
                  isNext ? "previous-disabled-button" : "previous-button"
                }
              >
                Next<span className="pi pi-angle-right"></span>
              </button>
            }
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
};

export default StudentsPerformanceList;
